import { useTranslation } from "react-i18next";
import { LinearProgress, Stack, styled, Typography } from "~/common/mui";

interface BulkUploadLoadingProps {
  operation: "preview" | "add";
}

export function BulkUploadLoading({ operation }: BulkUploadLoadingProps) {
  const { t } = useTranslation();
  return (
    <LoadingContainer data-operation={operation} data-testid="bulk-upload-loading" gap={2} aria-live="polite">
      <Typography variant="headlineSmall">
        {t(operation === "add" ? "adding.items.to.cart.text" : "processing.your.list.text")}
      </Typography>
      <LoadingProgress />
    </LoadingContainer>
  );
}

const LoadingContainer = styled(Stack)(({ theme }) => ({
  alignItems: "center",
  justifyContent: "center",
  minHeight: "320px",
  padding: theme.spacing(3),
}));

const LoadingProgress = styled(LinearProgress)({
  maxWidth: "360px",
  width: "100%",
});
